<template>
    <v-dialog v-model="dialog" max-width="1600" scrollable>
        <v-card>
            <div class="card-section-header px-6 py-4">
                <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                        <v-icon class="mr-2" color="white" size="18">mdi-email-outline</v-icon>
                        <span class="card-section-title">Sent Quote Emails</span>
                    </div>
                    <v-btn icon dark @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-card-text class="pa-4">
                <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
                <div v-else-if="emails.length === 0" class="text-center py-8">
                    <v-icon size="48" color="grey lighten-1">mdi-email-off-outline</v-icon>
                    <p class="mt-2 grey--text">No quote emails have been sent for this lead yet.</p>
                </div>
                <v-data-table
                    v-else
                    :headers="headers"
                    :items="emails"
                    :sort-by="'created_at'"
                    :sort-desc="true"
                    dense
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.subject }}</td>
                            <td>{{ item.sent_from }}</td>
                            <td>{{ item.sent_to }}</td>
                            <td>
                                <span v-if="item.sender">{{ item.sender.name }}</span>
                            </td>
                            <td>{{ $date(item.created_at).format('DD-MMM-YYYY h:mm A') }}</td>
                            <td>
                                <v-btn x-small depressed dark color="#3988AA" @click="viewEmail(item)">
                                    <v-icon x-small left>mdi-eye-outline</v-icon>View
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog v-model="view_email_dialog" max-width="1600" scrollable>
            <v-card>
                <div class="card-section-header px-6 py-4">
                    <div class="d-flex align-center justify-space-between">
                        <div class="d-flex align-center">
                            <v-icon class="mr-2" color="white" size="18">mdi-email-open-outline</v-icon>
                            <span class="card-section-title">{{ selected_email ? selected_email.subject : '' }}</span>
                        </div>
                        <v-btn icon dark @click="view_email_dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-card-text class="pa-4" v-if="selected_email">
                    <div class="mb-3">
                        <div><strong>From:</strong> {{ selected_email.sent_from }}</div>
                        <div><strong>To:</strong> {{ selected_email.sent_to }}</div>
                        <div v-if="selected_email.cc_email"><strong>CC:</strong> {{ selected_email.cc_email }}</div>
                        <div><strong>Date:</strong> {{ $date(selected_email.created_at).format('DD-MMM-YYYY h:mm A') }}</div>
                    </div>
                    <v-divider class="mb-3"></v-divider>
                    <div v-html="selected_email.body"></div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
export default {
    props: {
        sent_quotes_dialog: {
            type: Boolean,
            default: false,
        },
        lead_id: {
            type: [Number, String],
            default: null,
        },
    },
    data: () => ({
        headers: [
            { text: 'Subject', value: 'subject' },
            { text: 'From', value: 'sent_from' },
            { text: 'To', value: 'sent_to' },
            { text: 'Sent By', value: 'sender.name' },
            { text: 'Date', value: 'created_at', width: '170px' },
            { text: '', value: 'action', sortable: false, width: '80px' },
        ],
        emails: [],
        loading: false,
        view_email_dialog: false,
        selected_email: null,
    }),
    computed: {
        dialog: {
            get() {
                return this.sent_quotes_dialog
            },
            set(val) {
                if (!val) this.close()
            },
        },
    },
    watch: {
        sent_quotes_dialog(val) {
            if (val && this.lead_id) {
                this.fetchEmails()
            }
        },
    },
    methods: {
        async fetchEmails() {
            this.loading = true
            try {
                const response = await this.$axios.get(`admin/quotes/get_quote_emails/${this.lead_id}`)
                const result = response.data
                if (result.response) {
                    this.emails = result.data
                }
            } catch (e) {
                this.$toast.error('Failed to load sent quote emails')
            } finally {
                this.loading = false
            }
        },
        viewEmail(item) {
            this.selected_email = item
            this.view_email_dialog = true
        },
        close() {
            this.$emit('closeSentQuotesDialog')
        },
    },
}
</script>

<style scoped>
.card-section-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}
.card-section-title {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    color: white;
}
</style>
